import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const BestsellersListViewPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/kch/bestsellers-list-view/Page")
);
const BrandPageListViewPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/kch/brand-page-list-view/Page")
);
const ShipsNowProductGridPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/kch/ships-now-product-grid/Page")
);

export function KevinChikRoutes() {
  return (
    <Switch>
      <Route
        path="/kch/bestsellers-list-view"
        component={BestsellersListViewPage}
      />
      <Route
        path="/kch/brand-page-list-view"
        component={BrandPageListViewPage}
      />
      <Route
        path="/kch/ships-now-product-grid"
        component={ShipsNowProductGridPage}
      />
    </Switch>
  );
}

export const slug = "kch";
